import { render, staticRenderFns } from "./GridViewIcon.vue?vue&type=template&id=5525b7ec&scoped=true&"
import script from "./GridViewIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./GridViewIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5525b7ec",
  null
  
)

export default component.exports